import React from "react";
import { View, Dimensions, ActivityIndicator } from "react-native";
import { colors } from "../../const";
const { height, width } = Dimensions.get("screen");

function Loader({ visible, ...others }) {
    if (!visible) return null;
    return (
        <View
            style={{
                flex: 1,
                position: "absolute",
                height: "100%",
                width: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                justifyContent: "center",
                alignItems: "center"
            }}
        >

            <ActivityIndicator
                size="large"
                color={colors.white}
                {...others}
            />

        </View>
    )

}

export default Loader;
